import { render, staticRenderFns } from "./SupportCustomers.vue?vue&type=template&id=11817938&scoped=true&"
import script from "./SupportCustomers.vue?vue&type=script&lang=js&"
export * from "./SupportCustomers.vue?vue&type=script&lang=js&"
import style0 from "./SupportCustomers.vue?vue&type=style&index=0&id=11817938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11817938",
  null
  
)

export default component.exports